import type { ExplorerItem, Item } from "../types";

export const isTaskItem = (node: ExplorerItem): node is Item =>
  "taskId" in node && "statusCode" in node;

export const isTaskItemLockedByOther = (
  item: ExplorerItem,
  currentUserId: string | null
): boolean =>
  isTaskItem(item) && !!item.lock && (!currentUserId || item.lock.userId !== currentUserId);

type TreeSummary = {
  leafCount: number;
  disabledIds: Set<number>;
  selectableIds: number[];
};

const hasChildren = (node: ExplorerItem): node is ExplorerItem & { children: ExplorerItem[] } =>
  "children" in node && Array.isArray(node.children);

export const summarizeTree = (
  rootNodes: readonly ExplorerItem[],
  currentUserId: string | null
): TreeSummary => {
  let leafCount = 0;
  const disabledIds = new Set<number>();
  const selectableIds: number[] = [];

  const collect = (nodes: readonly ExplorerItem[]) => {
    for (const node of nodes) {
      if (isTaskItem(node)) {
        leafCount++;
        if (isTaskItemLockedByOther(node, currentUserId)) disabledIds.add(node.id);
        else selectableIds.push(node.id);
      }
      if (hasChildren(node)) collect(node.children);
    }
  };

  collect(rootNodes);
  return { leafCount, disabledIds, selectableIds };
};
